export default __webpack_public_path__ + "static/media/427.799f4dd0.jpg";